<h2 mat-dialog-title>{{ data.header }}</h2>

<ng-scrollbar mat-dialog-content [autoHeightDisabled]="false">
  <div class="scroll-bar-margin">
    <ng-container
      *ngTemplateOutlet="data.template; context: { $implicit: clickClose }"
    ></ng-container>
    @if (data.content) {
      <p [innerHTML]="data.content | safeHtml"></p>
    }
  </div>
</ng-scrollbar>

@if (!data.hideButtonBar) {
  <div mat-dialog-actions>
    <ng-container
      *ngTemplateOutlet="data.extraButtons; context: { $implicit: clickClose }"
    ></ng-container>
    @if (primaryButtonVariant === 'flat') {
      <button
        (click)="clickClose(true)"
        mat-flat-button
        [color]="primaryColor"
        [disabled]="data.form?.invalid"
      >
        {{ data.yesText }}
      </button>
    }
    @if (primaryButtonVariant === 'stroked') {
      <button
        (click)="clickClose(true)"
        mat-stroked-button
        [color]="primaryColor"
      >
        {{ data.yesText }}
      </button>
    }
    @if (primaryButtonVariant === 'basic') {
      <button (click)="clickClose(true)" mat-button [color]="primaryColor">
        {{ data.yesText }}
      </button>
    }
    @if (data.noText) {
      <button mat-stroked-button (click)="clickClose(false)">
        {{ data.noText }}
      </button>
    }
  </div>
}
